// extracted by mini-css-extract-plugin
module.exports = {"button":"GenericButton-GenericButton-button-1VdH8iJQ"};